import { render, staticRenderFns } from "./ProductShippingSelector.vue.html?vue&type=template&id=5d77f373&scoped=true&"
import script from "./ProductShippingSelector.component.js?vue&type=script&lang=vueJs&"
export * from "./ProductShippingSelector.component.js?vue&type=script&lang=vueJs&"
import style0 from "./ProductShippingSelector.scoped.scss?vue&type=style&index=0&id=5d77f373&prod&lang=vueScss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d77f373",
  null
  
)

export default component.exports